import React, { useState, useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { ModalContext } from "App";
import PinInput from "modules/common/components/PinInput";
import CountdownComponent from "modules/common/components/CountdownComponent";
import CmsContext from "../../../../../CmsContext";
import useFormValidator from "../../../../../useFormValidator";

import * as actions from "../../../actions";
import * as c from "../../../constants";

function MultiFactorAuthenticationEmail({
  email2fa,
  goBack,
  history,
  resendMfaOtp,
  isLoading,
  resending,
  mfaLogin,
  profile,
  selectedMfa,
  savePreferredLogin,
  temporaryToken,
  getProfileInfo,
  onCountdown,
  isResendTimerOTP,
  cooldownTime,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_LOGOS = cmsContext.findByType("LOGOS");
  const [showOTP, setShowOTP] = useState(false);
  const [rand, setRand] = useState(_.random(1, 1000));
  const [formData, setFormData] = useState({
    email: _.get(profile, "email"),
  });

  const formValidator = useFormValidator(formData, {
    email: "email",
  });

  useEffect(() => {
    formValidator.validate();
  }, [Object.values(formData).join(",")]);

  const handleGoBack = (e) => {
    e.preventDefault();

    goBack(0);
  };

  const handleGoBackConfirmation = (e) => {
    e.preventDefault();

    setShowOTP(false);
  };

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnchangePin = (otp) => {
    setFormData({
      ...formData,
      otp,
    });
  };

  const secretEmail = (val) => {
    return [...val].map((item, i) => (i > 1 && i < 9 ? "*" : item));
  };

  const handleNext = () => {
    const args = {
      receiver_type: "email",
      token: temporaryToken,
      email: !_.get(profile, "email") ? _.get(formData, "email") : _.get(profile, "email"),
    };

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" }).then((captcha_token) => {
        if (!isResendTimerOTP) {
          return email2fa({ ...args, recaptcha: captcha_token }, () => {
            setShowOTP(true);
            onCountdown();
          });
        }
        return setShowOTP(true);
      });
    });
  };

  const handleSubmitOTP = (e) => {
    e.preventDefault();

    const args = {
      secret: formData.otp,
      mfa_type: "email_otp",
      token: temporaryToken,
    };

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" }).then((captcha_token) => {
        mfaLogin({ ...args, recaptcha: captcha_token }, () => {
          const token = localStorage.getItem("token");
          if (selectedMfa === 1) {
            const mfaArgs = {
              token,
              preferred_mfa: "email_otp",
            };

            savePreferredLogin(mfaArgs, () => {
              getProfileInfo();
            });
          }
          setModal({ isOpen: false });
          history.push("/");
        });
      });
    });
  };

  const handleResendMfaOtp = (e) => {
    e.preventDefault();

    const args = {
      receiver_type: "email",
      token: temporaryToken,
      email: !_.get(profile, "email") ? _.get(formData, "email") : _.get(profile, "email"),
    };

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" }).then((captcha_token) => {
        if (!isResendTimerOTP) {
          return resendMfaOtp({ ...args, recaptcha: captcha_token }, () => {
            setRand(_.random(1, 1000));
            setShowOTP(true);
            onCountdown();
          });
        }
        return setShowOTP(true);
      });
    });
  };

  return (
    <>
      {!showOTP && (
        <>
          <div>
            <button onClick={handleGoBack} type="button" className="mfa-back-button cms-text-primary my-2">
              <i className="fas fa-chevron-left mfa-back-login" /> Back
            </button>
          </div>
          <div className="mfa-modal form-wrapper">
            <img src={_.get(CMS_LOGOS, "MAIN_LOGO.cdnUrl")} alt="" className="icon-logo mb-3" />
            <h2 className="mb-3 mt-6 font-weight-bold cms-text-primary">Multi-Factor Authentication</h2>
            <div className="mfa-setup-description text-left">
              {profile.is_email_2fa_enabled === true
                ? "To continue your login to your account"
                : "To continue setting up Email Authentication for your account"}
              , please confirm your email address below:
            </div>
            <div className="form-group prepend-form-left mt-2">
              <label htmlFor="name" className="mfa-label mb-0">
                Email Address {formValidator.renderMessage("email")}
              </label>
              <div className="inner-addon left-addon left-addon-button">
                <div className="btn btn-left" >
                  <i className="fas fa-envelope text-gray" />
                </div>
                <input
                  type="email"
                  placeholder="Email Address"
                  onChange={handleOnChange}
                  name="email"
                  value={_.get(formData, "email") || ""}
                  id="loginUsername"
                  disabled={_.get(profile, "email")}
                  className="form-control form-control-lg"
                  style={{ border: "1px solid #D3D3D3", borderRadius: "8px" }}
                />
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={handleNext}
                disabled={!_.get(formData, "email") || isResendTimerOTP || !formValidator.response.is_passed}
                className="mt-3 btn btn-block btn-primary cms-bg-color-primary cms-outline-primary"
              >
                <span className="font-weight-bold text-nowrap">Continue {cooldownTime > 0 && `(0:${cooldownTime.toString().padStart(2, "0")})`}</span>
              </button>
            </div>
          </div>
        </>
      )}
      {showOTP && (
        <>
          <div>
            <button onClick={handleGoBackConfirmation} type="button" className="mfa-back-button cms-text-primary my-2">
              <i className="fas fa-chevron-left mfa-back-login" /> Back
            </button>
          </div>
          <form className="mfa-modal" onSubmit={handleSubmitOTP}>
            <img src={_.get(CMS_LOGOS, "MAIN_LOGO.cdnUrl")} alt="" className="icon-logo" />
            <div className="form-header p-2 mt-2 cms-bg-color-primary-ligt mfa-description">
              We sent your One Time Password (OTP) to{" "}
              <span className="text-success">
                {_.get(formData, "email") ? secretEmail(_.get(formData, "email")) : secretEmail(_.get(formData, "email"))}
              </span>
              {!profile.is_email_2fa_enabled && (
                <div className="mt-2">
                  This will be used to set up <b> Email Authentication </b> in your account.
                </div>
              )}
            </div>
            <div className="col-12 mt-2">
              <PinInput onChange={handleOnchangePin} />
            </div>
            <div className="col-12 mt-2 text-center">
              <CountdownComponent key={`countdown-${rand}`} />
            </div>
            <div className="d-flex flex-column flex-md-row flex-lg-row flex-xl-row text-center">
              <div className="col-12 col-md-6">
                <button
                  onClick={handleResendMfaOtp}
                  type="submit"
                  className="btn btn-outline-primary mt-4 btn-block cms-text-primary cms-outline-primary"
                  disabled={isResendTimerOTP}
                >
                  {resending && <i className="fa fa-spin fa-spinner" />}
                  <span className="mr-2 label-small text-nowrap">Resend OTP {cooldownTime > 0 && `(0:${cooldownTime.toString().padStart(2, "0")})`}</span>
                </button>
              </div>
              <div className="col-12 col-md-6">
                <button type="submit" className="btn btn-primary mt-4 btn-block cms-bg-color-primary" disabled={isLoading || _.isEmpty(formData.otp)}>
                  {isLoading && <i className="fa fa-spin fa-spinner" />}
                  Submit
                </button>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col text-center d-flex align-items-center justify-content-center">
                <button type="button" onClick={handleGoBack} className="btn btn-change cms-text-primary">
                  <span className="font-weight-bold">Change Authentication Method</span>
                </button>
              </div>
            </div>
          </form>
        </>
      )}
    </>
  );
}

MultiFactorAuthenticationEmail.propTypes = {
  goBack: PropTypes.instanceOf(Function).isRequired,
  email2fa: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  resendMfaOtp: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  resending: PropTypes.bool.isRequired,
  mfaLogin: PropTypes.instanceOf(Function).isRequired,
  profile: PropTypes.instanceOf(Object).isRequired,
  savePreferredLogin: PropTypes.instanceOf(Function).isRequired,
  selectedMfa: PropTypes.number.isRequired,
  temporaryToken: PropTypes.string.isRequired,
  getProfileInfo: PropTypes.instanceOf(Function).isRequired,
  onCountdown: PropTypes.instanceOf(Function).isRequired,
  isResendTimerOTP: PropTypes.bool.isRequired,
  cooldownTime: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  temporaryToken: sessionStorage.getItem("temporaryToken") || "",
  isLoading: _.get(api, "loading", []).indexOf(c.ENABLE_2FA) > -1,
  resending: _.get(api, "loading", []).indexOf(c.RESEND_OTP) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
    getProfileInfo: actions.getProfile,
  }),
]);

export default enhance(MultiFactorAuthenticationEmail);
